<template>
  <svg stroke="currentColor" fill="none" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
  </svg>
</template>

<script>
export default {
  name: 'MenuCloseIcon',
};
</script>
